import React, { useMemo, Fragment, useEffect, useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { MaterialReactTable } from 'material-react-table';

const MpgServiceOfficeDialog = ({ open, setOpen, serviceOfficeListFromAPI, serviceOfficeItemsFromDialog, setServiceOfficeItemsFromDialog }) => {

    const tableInstanceRef = useRef(null);

    const columns = useMemo(
        () => [
            {
                accessorKey: "rightOfficeKey",
                id: 'rightOfficeKey',
                header: "Right Office Key",
                filterFn: 'contains',
                hide: true
            },
            {
                accessorKey: "rightOfficeCode",
                header: "Right Office Code",
                filterFn: 'contains'
            },
            {
                accessorKey: "masterRightOfficeName",
                header: "Right Office Name",
                filterFn: 'contains'
            },
        ],
        []
    );

    /**setting check box for already selected items */
    useEffect(() => {
        if (!!serviceOfficeItemsFromDialog && !!serviceOfficeItemsFromDialog.length) {
            /**{1:true,23:true} to maintain state for selected item*/
            let obj = {}
            serviceOfficeItemsFromDialog.forEach((item) => {
                return obj[`${item.rightOfficeKey}`] = true;
            })
            setRowSelection(obj)
        } else {
            setRowSelection({})
        }
    }, [serviceOfficeItemsFromDialog])

    /** */
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
    }

    //optionally, you can manage the row selection state yourself
    const [rowSelection, setRowSelection] = useState({});

    const handleAddList = () => {
        /**get list of selected objects */
        const selectedRowObjList = tableInstanceRef.current
            .getSelectedRowModel()
            .rows.map((eachSelectedRowModel) => {
                return eachSelectedRowModel.original
            });
        setServiceOfficeItemsFromDialog(selectedRowObjList)

        handleClose()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                Select Service Offices
                <IconButton
                    sx={{ ml: 'auto' }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <MaterialReactTable
                    tableInstanceRef={tableInstanceRef}
                    columns={columns}
                    data={serviceOfficeListFromAPI}
                    layoutMode="grid"
                    enableGlobalFilter={false}
                    enableDensityToggle={false}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true
                    }}
                    enableRowSelection
                    getRowId={(originalRow) => originalRow.rightOfficeKey}
                    onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                    state={{ rowSelection }}
                    enableStickyHeader
                />

            </DialogContent>
            <DialogActions>
                <Button type='button' onClick={() => {
                    handleAddList()
                }}>Add</Button>
                <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>

        </Dialog>
    )
}
export default MpgServiceOfficeDialog